import { QueryError } from './query-error'
import styles from './screen-state.module.css'

type ScreenStateProps = {
  title: string
  text?: string
  action?: { label: string; onClick: () => void }
}

export function ScreenState({ title, text, action }: ScreenStateProps) {
  return (
    <div className={styles.state} role="status">
      <h2 className={styles.title}>{title}</h2>
      {text ? <p className={styles.text}>{text}</p> : null}
      {action ? (
        <button type="button" className={styles.btn} onClick={action.onClick}>
          {action.label}
        </button>
      ) : null}
    </div>
  )
}

export function RouteError({ error }: { error?: unknown }) {
  return <QueryError error={error} />
}
